import api from './api';

const SEPARATOR = '|||';

// Der komplette KI-Prompt wird SERVERSEITIG in api.php gebaut.
// Der Client schickt nur validierte Parameter — so kann der Endpunkt
// nicht als generischer GPT-Proxy missbraucht werden.
export async function generateTexts(userPrompt, count, langCode, textType, options = {}) {
  const data = await api.proxyCall('generate', {
    prompt: userPrompt.trim(),
    count,
    lang: langCode,
    textType,
    style: options.style || 'normal',
    length: options.length || 'normal',
    faction: options.faction || '',
    class: options.wowClass || '',
    race: options.race || '',
  });

  if (!data.text) {
    throw new Error('No response from AI');
  }

  const messages = data.text
    .split(SEPARATOR)
    .map(line => line.trim())
    .filter(line => line.length > 0)
    .map(line => line.replace(/^\d+[\.\)]\s*/, '').replace(/^[-•]\s*/, ''))
    .filter(line => line.length > 0)
    .slice(0, count);

  return messages;
}
